import { FC, ChangeEvent } from 'react';
import * as XLSX from 'xlsx';
import { upsertPayslip } from '../../lib/payslips';
import { fetchUserIdByName } from '../../lib/employeeMap';
import type { Payslip } from '../../types/payslip';

const PayrollUpload: FC = () => {
  const handleFileUpload = async (event: ChangeEvent<HTMLInputElement>) => {
    try {
      const file = event.target.files?.[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = async (e) => {
        try {
          const data = new Uint8Array(e.target?.result as ArrayBuffer);
          const workbook = XLSX.read(data, { type: 'array' });
          const worksheet = workbook.Sheets[workbook.SheetNames[0]];
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as any[][];

          // Skip header rows
          const dataRows = jsonData.slice(3);
          const period = (jsonData[0][0] as string).toString().split('-')[1].trim();

          console.log('Processing data rows:', dataRows);

          for (const row of dataRows) {
            if (!row?.[0]) continue; // Skip empty rows

            const employeeName = row[0].toString().trim();
            console.log('Processing employee:', employeeName);
            
            const userId = await fetchUserIdByName(employeeName);
            if (!userId) {
              console.error(`No user ID found for employee: ${employeeName}`);
              continue;
            }

            const payslip: Payslip = {
              user_id: userId,
              period,
              daily_rate: parseFloat(row[1]) || 0,
              total_hours: parseFloat(row[2]) || 0,
              overtime_hours: parseFloat(row[3]) || 0,
              basic_pay: parseFloat(row[4]) || 0,
              holiday_pay: parseFloat(row[5]) || 0,
              incentives: parseFloat(row[6]) || 0,
              other_bonuses: parseFloat(row[7]) || 0,
              total_gross: parseFloat(row[8]) || 0,
              sss: parseFloat(row[9]) || 0,
              pagibig: parseFloat(row[10]) || 0,
              philhealth: parseFloat(row[11]) || 0,
              ca: parseFloat(row[12]) || 0,
              loan_deduction: parseFloat(row[13]) || 0,
              other_deductions: parseFloat(row[14]) || 0,
              total_deductions: parseFloat(row[15]) || 0,
              net_pay: parseFloat(row[16]) || 0
            };

            console.log('Attempting to upload payslip:', payslip);
            await upsertPayslip(payslip);
          }

          alert('Payroll data uploaded successfully!');
        } catch (error: any) {
          console.error('Error processing file:', error);
          alert(error?.message || 'Error processing file');
        }
      };

      reader.readAsArrayBuffer(file);

      // Reset file input
      if (event.target) {
        event.target.value = '';
      }
    } catch (error: any) {
      console.error('Error uploading payroll:', error);
      alert(error?.message || 'Error uploading file');
    }
  };

  return (
    <div className="p-4">
      <input
        type="file"
        accept=".xlsx,.xls"
        onChange={handleFileUpload}
        className="block w-full text-sm text-gray-500
          file:mr-4 file:py-2 file:px-4
          file:rounded-md file:border-0
          file:text-sm file:font-semibold
          file:bg-blue-50 file:text-blue-700
          hover:file:bg-blue-100"
      />
    </div>
  );
};

export default PayrollUpload; 